var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-layout"},[_c('app-side-menu'),_c('div',{staticClass:"content-container"},[_c('app-toolbar'),_c('div',{staticClass:"router-container custom-scroll"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }